import React, { CSSProperties } from 'react';

import styled from 'styled-components';
import Link from 'next/link';

import CheckboxOutline, { CheckboxContainer } from './variants/CheckboxOutline';
import { SeturCheckboxProps } from './CheckboxInterface';
import { CheckBoxSubTitle } from './variants/CheckboxOutline/styled';

const CheckboxVariants = {
  outline: CheckboxOutline,
};

export type { SeturCheckboxProps };

const Label = styled.span`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

const Checkbox = ({
  title,
  subTitle,
  className,
  variant = 'outline',
  testid = 'checkbox',
  labelAs = 'span',
  isRegion = false,
  labelStyle,
  subTitleStyle,
  ...rest
}: React.PropsWithChildren<
  SeturCheckboxProps & {
    labelStyle?: CSSProperties;
    subTitleStyle?: CSSProperties;
  }
>) => {
  const CheckBoxVariant = CheckboxVariants[variant];
  const toSeoUrl = (title: string): string => {
    const turkishMap: { [key: string]: string } = {
      ç: 'c',
      ğ: 'g',
      ı: 'i',
      ö: 'o',
      ş: 's',
      ü: 'u',
      İ: 'i',
      Ç: 'c',
      Ğ: 'g',
      Ö: 'o',
      Ş: 's',
      Ü: 'u',
    };

    return `/${title
      .toLowerCase()
      .split('')
      .map((char) => turkishMap[char] || char)
      .join('')
      .replace(/\s+/g, '-')
      .replace(/[^a-z0-9-]/g, '')}-otelleri`;
  };

  return (
    <CheckBoxVariant testid={testid} className={className} {...rest}>
      {title ? (
        isRegion ? (
          <Link
            href={toSeoUrl(title)}
            prefetch={false}
            title={`${title} Otelleri`}
            onClick={(e) => {
              e.preventDefault();
            }}
          >
            <Label
              title={subTitle ? `${title} (${subTitle})` : title}
              as={labelAs}
              style={labelStyle}
            >
              {subTitle ? `${title} (${subTitle})` : title}
            </Label>
          </Link>
        ) : (
          <Label
            title={subTitle ? `${title} (${subTitle})` : title}
            as={labelAs}
            style={labelStyle}
          >
            {title + ' '}

            {subTitle && (
              <CheckBoxSubTitle style={subTitleStyle}>
                {' '}
                ({subTitle})
              </CheckBoxSubTitle>
            )}
          </Label>
        )
      ) : (
        rest?.children
      )}
    </CheckBoxVariant>
  );
};

export default Checkbox;

export { CheckboxContainer };
